<template>
  <v-radio
    v-bind="filteredAttrs"
    :label="filteredAttrs.label"
    :class="[$attrs.class, 'v-selection-control']"
    :style="$attrs.style"
  />
</template>
<script lang="ts" setup>
import { useAttrs, computed } from 'vue';

const attrs = useAttrs();

const filteredAttrs = computed(() => {
  return Object.fromEntries(
    Object.entries(attrs).filter(([key]) => key !== 'class' && key !== 'style')
  );
});
</script>
<style lang="scss" scoped>
.v-selection-control {
  & > .v-text-field--outlined > .v-input__control > .v-field__input {
    background-color: rgb(var(--v-theme-secondary));
  }
  &
    > .v-text-field--outlined.v-input--is-focused
    > .v-input__control
    > .v-field__input,
  &
    > .v-text-field--outlined.v-input--is-dirty
    > .v-input__control
    > .v-field__input {
    background-color: rgb(var(--v-theme-white));
  }

  :deep(.v-label) {
    font-size: 1.125rem;
  }
}
</style>
